<template>
  <div :id="`accept-` + applicant.job_applicant_id" class="applicant-link">
    <div class="card">
      <router-link
        v-if="!withdrawn"
        :to="{
          name: 'view-healthcare-applicant',
          params: { id: applicant.job_applicant_id }
        }"
        title="Bekijk"
        class="card-body"
        :class="declined ? 'bg-cancelled' : ''"
        v-ripple="'rgba(192, 189, 187, 0.35)'"
      >
        <div class="card-top-row">
          <div v-if="parseInt(applicant.is_declined)" class="declined">
            Kandidaat afgewezen
          </div>
          <div v-else-if="parseInt(applicant.is_interview_invited)" class="recent">
            Recent uitgenodigd
          </div>
          <div v-else-if="parseInt(applicant.is_interested)" class="recent">
            Recent benaderd
          </div>
          <div v-else-if="parseInt(applicant.percentage) && !withdrawn" class="match_percentage">
            {{ parseInt(applicant.percentage) }}% match
          </div>
        </div>
        <div class="applicant-card-image">
          <img v-if="applicant.avatar" :src="applicant.avatar" class="img-item" />
          <svg-icon v-else icon="person_male" class="img-item"/>
          <div class="sd-title bold">
            {{ applicant.firstname }}
          </div>
        </div>
        <div class="applicant-card-spec">
            <ul>
                <li v-if="applicant.city">
                    <svg-icon icon="marker"></svg-icon>
                    <span v-if="applicant.name_location">{{ applicant.name_location }} ({{ applicant.city }})</span>
                    <span v-else>{{ applicant.city }}</span>
                </li>
                <li><svg-icon icon="first_aid_kit"></svg-icon>{{ applicant.groups[0].answer }} - {{ applicant.qualifications[0].answer }}</li>
                <li class="shift-items">
                    <template v-for="shift in this.shifts_arr">
                        <span class="shift-item">{{ shift }}</span>
                    </template>
                </li>
            </ul>
        </div>
        <button
          v-if="accept && !withdrawn"
          type="button"
          v-on:click.stop="onAccept(applicant.job_applicant_id)"
          class="btn btn-light btn-block"
        >
          Aannemen
        </button>
      </router-link>
      <div v-else class="card-body bg-cancelled">
        <div class="card-top-row">
          <div v-if="parseInt(applicant.is_interested)" class="recent">Recent benaderd</div>
          <div v-if="parseInt(applicant.is_interview_invited)" class="recent">Recent uitgenodigd</div>
        </div>
        <div class="applicant-card-image">
          <img v-if="applicant.avatar" :src="applicant.avatar" class="img-item" />
          <svg-icon v-else icon="person_male" class="img-item"/>
          <div class="sd-title bold">
            {{ applicant.firstname }}
          </div>
        </div>
        <div class="applicant-card-spec">
            <ul>
                <li v-if="applicant.city">
                    <svg-icon icon="marker"></svg-icon>
                    <span v-if="applicant.name_location">{{ applicant.name_location }} ({{ applicant.city }})</span>
                    <span v-else>{{ applicant.city }}</span>
                </li>
                <li><svg-icon icon="first_aid_kit"></svg-icon>{{ applicant.groups[0].answer }} - {{ applicant.qualifications[0].answer }}</li>
                <li class="shift-items">
                    <template v-for="shift in this.shifts_arr">
                        <span class="shift-item">{{ shift }}</span>
                    </template>
                </li>
            </ul>
          <div v-if="withdrawn" class="text-center mt-2">
            <strong>Sollicitatie ingetrokken</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";

export default {
  props: {
    applicant: Object,
    accept: Boolean,
    view: Boolean,
    dayData: Object,
  },
  data() {
    return {
      sub_branch: localStorage.getItem("subBranch"),
      withdrawn: false,
      declined: false,
        shifts_arr: [],
    };
  },
  async mounted() {
    this.declined = this.applicant.is_declined;
    this.withdrawn = this.applicant.is_withdrawn;
  },
    async created() {
        await this.fetchData();
    },
  computed: {
    func() {
      const func = JSON.parse(this.applicant.experience);
      if (typeof func !== 'undefined' && typeof func["position"] !== 'undefined' && func["position"][0]) {
        return func["position"][0];
      }
      return "-";
    },
    subtitle() {
      let working_dates = JSON.parse(JSON.parse(this.applicant.working_dates));
      let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
      let _subtitle = "";
      if (Object.keys(working_dates).length > 1) {
        _subtitle = formatedFirstDate + ": meerdere dagen";
      } else {
        _subtitle = formatedFirstDate + ": één dag";
      }
      return _subtitle;
    }
  },
  methods: {
    async onAccept(id) {
      this.$emit("notification", "comment");
      this.$emit("job-applicant-id-change", id);
    },
      async fetchData() {
          // this.shifts_arr = this.job.healthcare_availability.split(", ");
          const raw = this.applicant.healthcare_availability;
          if (!raw) return ['Nog niet ingevuld'];

          let parsed;
          try {
              parsed = JSON.parse(raw);
          } catch {
              return ['Nog niet ingevuld'];
          }

          const labelMap = {
              day: 'Dag',
              evening: 'Avond',
              night: 'Nacht',
              weekend: 'Weekend',
              hasTransport: 'De zorgmedewerker heeft eigen vervoer nodig'
          };

          this.shifts_arr = Object.keys(parsed)
              .filter(key => parsed[key] === true)
              .map(key => labelMap[key])

          const hasTransport = this.shifts_arr.indexOf('De zorgmedewerker heeft eigen vervoer nodig');
          if (hasTransport !== -1) {
              this.shifts_arr.splice(hasTransport, 1);
              this.shifts_arr.push('De zorgmedewerker heeft eigen vervoer nodig');
          }
      }
  },
  components: {
    Achievements
  }
};
</script>

<style scoped>
.applicant-link {
  height: 100%;
}

.applicant-link .card {
  height: 100%;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
}

.applicant-link .card .card-body {
  height: 100%;
  color: #64513D;
}

.applicant-link .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  left: 0;
  width: 100%;
}

.applicant-link .card-top-row .match_percentage,
.applicant-link .card-top-row .recent,
.applicant-link .card-top-row .declined {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 20px;
  font-weight: 400;
}

.applicant-link .card-top-row .match_percentage {
  height: 25px;
  width: 85px;
  background-color: #FFCD00;
}

.applicant-link .card-top-row .recent,
.applicant-link .card-top-row .declined {
  height: 25px;
  width: 115px;
  background-color: #F6F6F6;
}

.applicant-link .card-top-row .declined {
  width: 135px;
}

.applicant-link .applicant-card-image {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}

.applicant-link .applicant-card-image .img-item {
  display: block;
  object-fit: cover;
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 100px;
  border: 2px solid #F6F6F6;
}

.applicant-link .applicant-card-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 2px;
}

.applicant-link .applicant-card-image .sd-title {
  margin-left: 10px;
}

.applicant-link .applicant-card-spec > div {
  display: flex;
}

.applicant-link .applicant-card-spec /deep/ svg {
  min-width: 15px;
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-top: 3px;
  color: #FFCD00;
}

.applicant-link .applicant-card-spec .achievements_container {
  margin-top: 15px;
}

.job-title {
  margin-bottom: 0;
}

.text.job {
  font-size: 11px;
  line-height: 150%;
}

.bg-cancelled {
  filter: grayscale(1);
  user-select: none;
}

.applicant-link .applicant-card-spec ul {
    font-size: 12px;
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.applicant-link .applicant-card-spec ul li {
    display: flex;
    align-items: center;
}

.applicant-link .applicant-card-spec ul .shift-items {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    flex-wrap: wrap;
    gap: 10px;
}

.applicant-link .applicant-card-spec ul .shift-items .shift-item {
    background-color: #f6f6f6;
    padding: 7px;
    color: black;
    line-height: 1;
    border-radius: 10px;
}

.applicant-link .applicant-card-spec ul li:not(:last-child) {
    margin-bottom: 10px;
}

</style>
